import { TileType } from '@varo/graphql-schema-types';

const homeTileTypes = [
  TileType.HomeTilesV2,
  TileType.List,
  TileType.VxlCardGroupTile,
  TileType.VxlTrackerCardTile,

  TileType.QuickAction,
  TileType.MarketingContentCard,
  TileType.MarketingCarousel,
  TileType.NextBestActionTile,

  // Internal Accounts
  TileType.InternalAccount,
  TileType.AccountAction,
  TileType.CardTrackerAttachment,

  // Lending
  TileType.CreditScoreTile,
  TileType.ProgressTrackerTile,

  TileType.VxlSideBySideTile,
  TileType.AdvanceAccountCardSquareTile,
  TileType.VlocAccountCardSquareTile,
  TileType.PayOverTimeItemsTile,

  // Offers / Promotions
  TileType.PartnerOffer,
  TileType.ProductOffer,
  TileType.Promotion,
  TileType.BannerPromotion,
  TileType.ProductOfferSingleCardTile,
  TileType.TopPerks,
  TileType.VaroToAnyone,

  // External Accounts
  TileType.ExternalAccountsTile,
  TileType.LinkedAccounts,
  TileType.ManageExternalAccounts,

  //Column tax
  TileType.ColumnTaxTile,
  TileType.ProductOfferSingleCardTile,

  // Self Funded Offer
  TileType.SelfFundedOfferTile,

  // Discover More
  TileType.VxlCardGroupDiscoverMoreTile,

  // Onboarding Checklist
  TileType.VxlCardGroupChecklistTile,
  TileType.GetTheVaroAppTile,
  TileType.FundAccountMoveMoneyOrSetUpDdTile,
  TileType.MakeYourFirstPurchaseTile,
  TileType.SetUpCardTile,

  // Home Redesign
  TileType.SdVerticalStackContainerTile,
  TileType.FullWidthTextComponentTile,
];

export default homeTileTypes;
